export default {"src":"/_next/static/media/usage-limit.6a351204.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};